module.exports = __webpack_public_path__ + "img/default-image.2910c67e.png";